import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Globals } from '../../../shared/globals';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  userconfig: any;
  userconfig1: any;
  imagePath: any;
  headertitle = "HỆ THỐNG QUẢN LÝ THỜI GIAN HỌC LÝ THUYẾT MÔN PHÁP LUẬT GTĐB";
  themes = [
    {
      value: 'ecotek',
      name: 'EcoTek',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },    
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Đổi mật khẩu', link:'/pages/changePass' }, { title: 'Đăng xuất', link:'/auth/logout' } ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService, 
              private domsanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    //this.username = localStorage.getItem('username');
    //console.log(Globals.userconfig);
    this.userconfig = JSON.parse(localStorage.getItem('userconfig'));
    //this.userconfig1 = Globals.userconfig;
    //console.log(this.userconfig1);
        //console.log(this.userconfig);
    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      if(this.userconfig)
      {
        this.imagePath = this.domsanitizer.bypassSecurityTrustResourceUrl(this.userconfig.Logo);
        if(this.userconfig.AppModuleType==1)
        {
          this.headertitle = "HỆ THỐNG QUẢN LÝ THỜI GIAN HỌC LÝ THUYẾT MÔN PHÁP LUẬT GTĐB";
        }
        else if(this.userconfig.AppModuleType==2)
        {
          this.headertitle = "TRUNG TÂM GIÁM SÁT THỜI GIAN VÀ QUÃNG ĐƯỜNG HỌC THỰC HÀNH LÁI XE Ô TÔ";
        }
        else if (this.userconfig.AppModuleType==3)
        {
          this.headertitle = "TRUNG TÂM GIÁM SÁT THỜI GIAN VÀ QUÃNG ĐƯỜNG HỌC THỰC HÀNH LÁI XE Ô TÔ";
        }
        
        //console.log(this.imagePath);
      }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  getTenCSDT()
  {
    if(Globals)
    {
      if(Globals.userconfig)
      {
        return Globals.userconfig.TenCSDT;
      }
      else
      {
        if(this.userconfig)
        {
          if(this.userconfig.TenCSDT)
          {
            return this.userconfig.TenCSDT;
          }
        }
        return '';
      }
    }
    else
    {
      return '';
    }    
  }

  getDiaChi()
  {
    if(Globals)
    {
      if(Globals.userconfig)
      {
        return "Địa Chỉ: " + Globals.userconfig.Diachi;
      }
      else
      {
        if(this.userconfig)
        {
          if(this.userconfig.Diachi)
          {
            return "Địa Chỉ: "+  this.userconfig.Diachi;
          }
        }
        return '';
      }
    }
    else
    {
      return '';
    }    
  }
  getLogo()
  {
    if(Globals)
    {
      if(Globals.userconfig)
      {
        if(Globals.userconfig.Logo)
          {
            return this.domsanitizer.bypassSecurityTrustResourceUrl(Globals.userconfig.Logo);
          }
      }
      else
      {
        if(this.userconfig)
        {
          if(this.userconfig.Logo)
          {
            return this.domsanitizer.bypassSecurityTrustResourceUrl(this.userconfig.Logo);
          }
        }
        var logo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAIAAAD+THXTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAATDSURBVGhD7ZpdaJtVGMf/bdOmXZrGmVS3dvixYm2YyESwKhN2oReO4YXsQlAvvNt2JbILdeid20DQXsgUxM/hjYgiKigI6jLQCoM6XBOylrTr1nZd+pG0aT6b1+fkfQjttq4557zv2zTmR2j+57yHnP7zPuc55z0nDYZhoLZo5PcaQs9SZgaZOOuqQc9S7FNETrGuGvQDr8jvVYNeegifQmYajwxwsczceaRGUEijrRs7nuFK4vo5pEZhFNHUjgbgrqfh3i7qZ//C0gjoH/Hci86nSk3V0b5LxgqLMpF3cfEtMczyCVx6H+GTXB/7HLGP0exDagzjnyE5jMKCqP/3bYx+iEIKmSlETiL2Sam1BnSX1Bk+YZw/ytpkbsg4+6wRH+Ri7IwoJsJC//miMfFtqZb0C8bUz0JM/SIa5OZKtYYx8Z3xxwEju8BFJfTv0tqxtBRF853wP8bF+16i2MbyhNDFDJrcpVrA5UNjqxDJCDoeQnMp/IjA4zQUkL7CRSW0LRXXBl5+Hq5trE0a21BYEsJzP0Y+QOiAeBkF+J8QlTe0N32a7VXRsyRSy9q75N4hRlG5MpdAcRltXcgnkbyIvjfQcwQPvIpHP0JTi2jgvhvp6VLTEtlr4m/rzlJBET1LlLUoTyWj/KLs5++HkcPYV+Kbzs5i/Eu094rKYl60nw0hPYXsDOYGRZEIPIn0ZUz+iJWc8Hb5awT2wXMPX1VCL4lH38O1X1mTvZ3Poecw4iFcOo1CQlR6H0TvMWzrFvrC62LMuP1YyWL6J2HVzP6TP2DsC6wsC729H33H4PIIrYyZJawnv2QU86yJmbPG36+wJub/EYlucZSLhF6WW412elgP+qYbXKyJpjYRltEBJIYxP4SZ3+DZjfbdfJVo8bHQxsGHi6vfi1VFZhKudnQE0f08Wjv5kqXU4POSI5ZS42JxZEILIlrI2Yk9lmg6olno+u9IhpGb5crVtPhF7HXuR8ceC0eRidWWFqO48g3i57hYCTQR7ToEby8XtbHOEk2s4XewGOGiLN4+BI+LWUsbiyzR9D96mrUOPUfRdZC1KlZYCp+Qi7TbQ3EYfJO1EnqWNINtPSh57B1QDkI9S0OvWe/HhFz1n2EticaCiOLNJj8EpX76fCVULVE+sHD83BL6fOpFHiVLNIQsyW8bQr1QX5IoWaKU4BjyfclbovWBfUPoZqgv6lEGeUu03nEYyR4lLdF61O6scDPUI/VbMZKWaH29KcRDLCpA0hI9L2wKiQssKkD2LoVZOIxMtMuOJelZwnlkLNHz9iayUGnsyVgq7x9UN5KBtxX4n1tqtngrxyZkLNm8/7YBdzzMYiMkA48eNqseSUsdQRYOE9jHogIkLXXuZ+EwvkqjjpC9S3tYOExA4scQsmPJJxUD1uDtk9o3l7RE7DrEwjF6DrOoDHlL3l7xtTkG9SV5AiBviQgeZ+EA8n0pWXL7xX68A1Av8tvISpaIroO25wn6fKVTDL098cGX7Xoo3Jw9cWLvgC1LJPPkQpX6+dJ61NopoEmtndWWUThRJzO0PqjGE/XViH3mkNhPvI03GjO0vqb1aLX/7uGW3LBfVfHzqRqOWHIWvXmpKqlb2grULW0F6pa2AnVL1Q/wHxIwHlxT9tMXAAAAAElFTkSuQmCC';
        return this.domsanitizer.bypassSecurityTrustResourceUrl(logo);
      }
    }
    var logo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAIAAAD+THXTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAATDSURBVGhD7ZpdaJtVGMf/bdOmXZrGmVS3dvixYm2YyESwKhN2oReO4YXsQlAvvNt2JbILdeid20DQXsgUxM/hjYgiKigI6jLQCoM6XBOylrTr1nZd+pG0aT6b1+fkfQjttq4557zv2zTmR2j+57yHnP7zPuc55z0nDYZhoLZo5PcaQs9SZgaZOOuqQc9S7FNETrGuGvQDr8jvVYNeegifQmYajwxwsczceaRGUEijrRs7nuFK4vo5pEZhFNHUjgbgrqfh3i7qZ//C0gjoH/Hci86nSk3V0b5LxgqLMpF3cfEtMczyCVx6H+GTXB/7HLGP0exDagzjnyE5jMKCqP/3bYx+iEIKmSlETiL2Sam1BnSX1Bk+YZw/ytpkbsg4+6wRH+Ri7IwoJsJC//miMfFtqZb0C8bUz0JM/SIa5OZKtYYx8Z3xxwEju8BFJfTv0tqxtBRF853wP8bF+16i2MbyhNDFDJrcpVrA5UNjqxDJCDoeQnMp/IjA4zQUkL7CRSW0LRXXBl5+Hq5trE0a21BYEsJzP0Y+QOiAeBkF+J8QlTe0N32a7VXRsyRSy9q75N4hRlG5MpdAcRltXcgnkbyIvjfQcwQPvIpHP0JTi2jgvhvp6VLTEtlr4m/rzlJBET1LlLUoTyWj/KLs5++HkcPYV+Kbzs5i/Eu094rKYl60nw0hPYXsDOYGRZEIPIn0ZUz+iJWc8Hb5awT2wXMPX1VCL4lH38O1X1mTvZ3Poecw4iFcOo1CQlR6H0TvMWzrFvrC62LMuP1YyWL6J2HVzP6TP2DsC6wsC729H33H4PIIrYyZJawnv2QU86yJmbPG36+wJub/EYlucZSLhF6WW412elgP+qYbXKyJpjYRltEBJIYxP4SZ3+DZjfbdfJVo8bHQxsGHi6vfi1VFZhKudnQE0f08Wjv5kqXU4POSI5ZS42JxZEILIlrI2Yk9lmg6olno+u9IhpGb5crVtPhF7HXuR8ceC0eRidWWFqO48g3i57hYCTQR7ToEby8XtbHOEk2s4XewGOGiLN4+BI+LWUsbiyzR9D96mrUOPUfRdZC1KlZYCp+Qi7TbQ3EYfJO1EnqWNINtPSh57B1QDkI9S0OvWe/HhFz1n2EticaCiOLNJj8EpX76fCVULVE+sHD83BL6fOpFHiVLNIQsyW8bQr1QX5IoWaKU4BjyfclbovWBfUPoZqgv6lEGeUu03nEYyR4lLdF61O6scDPUI/VbMZKWaH29KcRDLCpA0hI9L2wKiQssKkD2LoVZOIxMtMuOJelZwnlkLNHz9iayUGnsyVgq7x9UN5KBtxX4n1tqtngrxyZkLNm8/7YBdzzMYiMkA48eNqseSUsdQRYOE9jHogIkLXXuZ+EwvkqjjpC9S3tYOExA4scQsmPJJxUD1uDtk9o3l7RE7DrEwjF6DrOoDHlL3l7xtTkG9SV5AiBviQgeZ+EA8n0pWXL7xX68A1Av8tvISpaIroO25wn6fKVTDL098cGX7Xoo3Jw9cWLvgC1LJPPkQpX6+dJ61NopoEmtndWWUThRJzO0PqjGE/XViH3mkNhPvI03GjO0vqb1aLX/7uGW3LBfVfHzqRqOWHIWvXmpKqlb2grULW0F6pa2AnVL1Q/wHxIwHlxT9tMXAAAAAElFTkSuQmCC';
    return this.domsanitizer.bypassSecurityTrustResourceUrl(logo);
    //this.imagePath = this.domsanitizer.bypassSecurityTrustResourceUrl(this.userconfig.Logo);
  }
}
